import axios from "axios";
import { loginCookieName } from "../App";
import { getCookie } from "../Cookie";

const ENTRY_POINT = process.env.REACT_APP_BACKEND_API;
// const ENTRY_POINT = "http://localhost:7980/api/";
// const ENTRY_POINT = "http://3.77.42.87:7980/api/";

const ax = axios.create({
  baseURL: ENTRY_POINT,
  headers: {
    Authorization: getCookie("sugar_editor_authentication"),
  },
});

const convertFileToBlob = (file, contentType = "application/octet-stream") => {
  if (file instanceof Blob) return file;

  return new Blob([new Uint8Array(file, 0, file?.byteLength)], {
    type: contentType,
  });
};

const convertObjectToBlob = (object) => {
  return new Blob([JSON.stringify(object)], {
    type: "application/json",
  });
};

const api = {
  cdnAlive: true,

  getProductVariantOptions: async (productId) => {
    return await axios.get(ENTRY_POINT + "product/variant/get/" + productId, {
      headers: {
        Authorization: getCookie(loginCookieName),
      },
    });
  },

  productSetDisabled: async (productId, disabled) => {
    return await axios.put(
      ENTRY_POINT + "products/set-disabled/" + productId + "?val=" + disabled,
      {
        headers: {
          Authorization: getCookie(loginCookieName),
        },
      }
    );
  },

  getProductVariantProducts: async (productId) => {
    return await axios.get(
      ENTRY_POINT + "product/variant/product/" + productId,
      {
        headers: {
          Authorization: getCookie(loginCookieName),
        },
      }
    );
  },

  getProductPartGroups: async (productId) => {
    return await axios.get(
      ENTRY_POINT + `product/material/group/part/get/` + productId,
      {
        headers: {
          Authorization: getCookie(loginCookieName),
        },
      }
    );
  },

  getProductParts: async (productId) => {
    return await axios.get(
      ENTRY_POINT + "material/list/partAndRules/" + productId,
      {
        headers: {
          Authorization: getCookie(loginCookieName),
        },
      }
    );
  },

  getProductMaterials: async (productId) => {
    return await axios.get(
      ENTRY_POINT + `product/material/combine/materials/` + productId,
      {
        headers: {
          Authorization: getCookie(loginCookieName),
        },
      }
    );
  },

  getMaterialGroupMaterials: async (groupsIds) => {
    if (!groupsIds || groupsIds.length == 0) return;

    let url = "material/list/bygroup/";
    return axios({
      method: "post",
      url: ENTRY_POINT + url,
      data: { groupIds: groupsIds },
      headers: {
        Authorization: getCookie(loginCookieName),
      },
    });
  },

  getMaterialInfoList: async () => {
    return await axios.get(ENTRY_POINT + "material/list/info", {
      headers: {
        Authorization: getCookie(loginCookieName),
      },
    });
  },
  getTags: async () => {
    return await axios.get(ENTRY_POINT + "sugar-tag", {
      headers: {
        Authorization: getCookie(loginCookieName),
      },
    });
  },
  sendImages: async (id, formData) => {
    return await axios.post(
      ENTRY_POINT + "products/2/addimages/" + id,
      formData,
      {
        headers: {
          Authorization: getCookie(loginCookieName),
        },
      }
    );
  },
  getTagGroups: async () => {
    return await axios.get(ENTRY_POINT + "sugar-tag/group/getAll", {
      headers: {
        Authorization: getCookie(loginCookieName),
      },
    });
  },
  addTagGroupsToProduct: async (tagGroups, productId) => {
    const formData = new FormData();
    tagGroups.forEach((tag) =>
      formData.append("sugarTagGroupIdList", tag.value)
    );
    formData.append("productId", productId);
    return await axios.post(
      ENTRY_POINT + "sugar-tag/catalog-product/add-group-multiple",
      formData,
      {
        header: {
          Authorization: getCookie(loginCookieName),
        },
      }
    );
  },
  addTagGroupsToMaterial: async (tagGroups, materialId) => {
    const formData = new FormData();
    tagGroups.forEach((tag) =>
      formData.append("sugarTagGroupIdList", tag.value)
    );
    formData.append("materialId", materialId);
    return await axios.post(
      ENTRY_POINT + "sugar-tag/material/add-group-multiple",
      formData,
      {
        header: {
          Authorization: getCookie(loginCookieName),
        },
      }
    );
  },

  getMaterialInfoListByCompany: async (companyId) => {
    return await axios.get(
      ENTRY_POINT + "material/list/info/bycompany/" + companyId,
      {
        headers: {
          Authorization: getCookie(loginCookieName),
        },
      }
    );
  },

  deleteProductPartGroup: async (productId) => {
    return await axios.post(
      ENTRY_POINT + "product/material/group/part/delete/" + productId,
      null,
      {
        headers: {
          Authorization: getCookie(loginCookieName),
        },
      }
    );
  },

  deleteMaterial: async (materialId) => {
    return await axios.post(
      ENTRY_POINT + "material/delete/" + materialId,
      null,
      {
        headers: {
          Authorization: getCookie(loginCookieName),
        },
      }
    );
  },

  getGlobalCategories: async () => {
    return await axios.get(ENTRY_POINT + "editor/global/category/list", {
      headers: {
        Authorization: getCookie(loginCookieName),
      },
    });
  },

  getCategories: async () => {
    return await axios.get(ENTRY_POINT + "editor/category/list", {
      timeout: 100000,
      headers: {
        Authorization: getCookie(loginCookieName),
      },
    });
  },

  saveProductPartGroup: async (productPartGroup) => {
    const formData = new FormData();

    formData.append(
      "productPartGroup",
      new Blob([JSON.stringify(productPartGroup)], { type: "application/json" })
    );

    return await axios.post(
      ENTRY_POINT + "product/material/group/part/save",
      formData,
      {
        headers: {
          Authorization: getCookie(loginCookieName),
          "Content-Type": "multipart/form-data",
        },
      }
    );
  },

  saveProductVariant: async (variantOption) => {
    const formData = new FormData();

    formData.append(
      "variantGroup",
      new Blob([JSON.stringify(variantOption)], { type: "application/json" })
    );

    formData.append(
      "thumbnailFile",
      new Blob([34234234], { type: "application/octet-stream" })
    );
    return await axios.post(ENTRY_POINT + "product/variant/save/", formData, {
      headers: {
        Authorization: getCookie(loginCookieName),
        "Content-Type": "multipart/form-data",
      },
    });
  },

  deleteProductVariant: async (variantId) => {
    return await axios.post(
      ENTRY_POINT + "product/variant/delete/" + variantId,
      null,
      {
        headers: {
          Authorization: getCookie(loginCookieName),
        },
      }
    );
  },

  getProductCombines: async (productId) => {
    return await axios.post(
      ENTRY_POINT + "product/material/combine/get/" + productId,
      null,
      {
        headers: {
          Authorization: getCookie(loginCookieName),
        },
      }
    );
  },

  deleteProductCombine: async (variantId) => {
    return await axios.post(
      ENTRY_POINT + "product/material/combine/delete/" + variantId,
      null,
      {
        headers: {
          Authorization: getCookie(loginCookieName),
        },
      }
    );
  },

  saveProductCombine: async (combine) => {
    const formData = new FormData();
    formData.append(
      "combine",
      new Blob([JSON.stringify(combine)], { type: "application/json" })
    );
    return await axios.post(
      ENTRY_POINT + "product/material/combine/save/",
      formData,
      {
        headers: {
          Authorization: getCookie(loginCookieName),
        },
      }
    );
  },

  getProductMaterialGroups: async (productId) => {
    return await axios.get(
      ENTRY_POINT + "material/listProductGroups/" + productId,
      {
        headers: {
          Authorization: getCookie(loginCookieName),
        },
      }
    );
  },

  getCompanyMaterialGroups: async (companyId) => {
    return await axios.get(
      ENTRY_POINT + `material/group/list?companyId=${companyId}`,
      {
        headers: {
          Authorization: getCookie(loginCookieName),
        },
      }
    );
  },
  getMaterialGroupsByCompanyId: async (companyId) => {
    return await axios.get(
      ENTRY_POINT + `material/groupByCompany/list?companyId=${companyId}`,
      {
        headers: {
          Authorization: getCookie(loginCookieName),
        },
      }
    );
  },

  updateTagsOfProduct: async (productId, tags) => {
    const formData = new FormData();
    formData.append("id", productId);
    tags.forEach((tag) => formData.append("tagIds", tag.value));

    return await axios.post(
      ENTRY_POINT + "sugar-tag/catalog-product/update",
      formData,
      {
        headers: {
          Authorization: getCookie(loginCookieName),
        },
      }
    );
  },
  updateTagsOfMaterial: async (tags, materialId) => {
    const formData = new FormData();
    tags.forEach((tag) => formData.append("tagIds", tag.value));
    formData.append("id", materialId);
    return await axios.post(
      ENTRY_POINT + "sugar-tag/material/update",
      formData,
      {
        headers: {
          Authorization: getCookie(loginCookieName),
        },
      }
    );
  },
  getTagsByMaterialId: async (id) => {
    return await axios.get(ENTRY_POINT + "sugar-tag/material/get-by-id/" + id, {
      headers: {
        Authorization: getCookie(loginCookieName),
      },
    });
  },
  getTagsByProductId: async (id) => {
    return await axios.get(
      ENTRY_POINT + "sugar-tag/catalog-product/get-by-id/" + id,
      {
        headers: {
          Authorization: getCookie(loginCookieName),
        },
      }
    );
  },
  addTagToMaterial: async (tags, materialId) => {
    const formData = new FormData();
    tags.forEach((tag) => formData.append("tagIds", tag.value));
    formData.append("materialId  ", materialId);
    return await axios.post(
      ENTRY_POINT + "sugar-tag/material/add-multiple",
      formData,
      {
        headers: {
          Authorization: getCookie(loginCookieName),
        },
      }
    );
  },
  addTagToProduct: async (tags, productId) => {
    const formData = new FormData();
    tags.forEach((tag) => formData.append("tagIds", tag.value));
    formData.append("productId", productId);
    return await axios.post(
      ENTRY_POINT + "sugar-tag/catalog-product/add-multiple",
      formData,
      {
        headers: {
          Authorization: getCookie(loginCookieName),
        },
      }
    );
  },

  createNewTag: async (formData) => {
    return await axios.post(
      ENTRY_POINT + "sugar-tag" + "/create",
      {
        name: formData.find((field) => field.name === "name").value,
        type: formData.find((field) => field.name === "type").value,
      },
      {
        headers: {
          Authorization: getCookie(loginCookieName),
        },
      }
    );
  },

  updateBaseAoMapResolution: async (baseAoMap, id) => {
    const formData = new FormData();
    formData.append("id", id);
    formData.append("baseAoMapResolution", baseAoMap);
    return await axios.post(
      ENTRY_POINT + "material/update/baseAoMapResolution",
      formData,
      {
        headers: {
          Authorization: getCookie(loginCookieName),
        },
      }
    );
  },

  updateBaseNormalMapResolution: async (baseNormalMap, id) => {
    const formData = new FormData();
    formData.append("id", id);
    formData.append("baseNormalMapResolution", baseNormalMap);
    return await axios.post(
      ENTRY_POINT + "material/update/baseNormalMapResolution",
      formData,
      {
        headers: {
          Authorization: getCookie(loginCookieName),
        },
      }
    );
  },

  convertGlbToFbx: async (glbFile) => {
    const formData = new FormData();
    formData.append(
      "file",
      convertFileToBlob(glbFile, "model/gltf-binary"),
      "model.glb"
    );
    return await axios.post(
      ENTRY_POINT + "blender/convert-glb-to-fbx",
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: getCookie(loginCookieName),
        },
        responseType: "arraybuffer",
      }
    );
  },

  saveProduct: async (
    productInfo,
    originalFile = null,
    thumbnailFile = null,
    posterFile = null,
    usdzFile = null
  ) => {
    const formData = new FormData();
    const productBlob = convertObjectToBlob(productInfo);
    formData.append("catalogProduct", productBlob);

    if (originalFile) {
      originalFile = convertFileToBlob(originalFile);
      formData.append("originalFile", originalFile);
    }

    if (thumbnailFile) {
      thumbnailFile = convertFileToBlob(thumbnailFile);
      formData.append("thumbnailFile", thumbnailFile);
    }

    if (posterFile) {
      posterFile = convertFileToBlob(posterFile);
      formData.append("posterFile", posterFile);
    }

    if (usdzFile) {
      usdzFile = convertFileToBlob(usdzFile, "application/usdz");
      formData.append("usdzFile", usdzFile);
    }

    return await axios({
      method: "post",
      url: ENTRY_POINT + "editor/save/product",
      data: formData,
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: getCookie(loginCookieName),
      },
    });
  },

  createJointedProduct: async (productId, jointDefinition) => {
    const url = new URL(ENTRY_POINT + "editor/create-joint-product");
    url.searchParams.append("productId", productId);

    return await axios({
      method: "post",
      url: url.toString(),
      data: jointDefinition,
      headers: {
        Authorization: getCookie(loginCookieName),
        "Content-Type": "text/plain",
      },
    });
  },

  addImageToProduct: async (productId, images = []) => {
    const formData = new FormData();

    images.forEach((image) => {
      formData.append("images", image);
    });

    return await ax.get("/product/add-image/" + productId);
  },
};

export default api;
